import { IError } from './api-types';

export function handleQueryError(err: IError) {
  let logMessage = true;
  switch (err.status) {
    case 401:
    case 403:
    case 404:
      // Don't report these errors. They are expected.
      logMessage = false;
      break;
  }

  if (logMessage) {
    // eslint-disable-next-line no-console
    console.warn(err.message || 'Query error', {
      request: err.request,
      response: err.response,
      json: err.details,
    });
  }
}
